/*
 * @Author: 鸦雀銮翎
 * @Date: 2023-02-20 08:54:40
 * @LastEditTime: 2024-03-08 15:24:59
 * @Description:
 * @FilePath: \website\src\assets\js\api.js
 * 可以输入预定的版权声明、个性签名、空行等
 */
import { service, market } from './request'



class api {


  getIntroduceJson(name) {
    return service.get(`http://wwwadm.tudouec.com/profile/resource/${name}.json`, {}, {})
  }

  /**
   * 获取新闻列表
   * @param {*} query
   * @param {*} config
   * @returns
   */
  getNewsList(query = {}, config = {}) {
    return service.get(`/www/api/news/${query.type}`, {params:query}, config)
  }

  /**
   * 获取可视数据内容
   * @param {*} query
   * @param {*} config
   * @returns
   */
  getPriceDataView(query = {}, config = {}) {
    return service.get(`/www/api/priceDataView?pageSize=${query.pageSize}&pageNum=${query.pageNum}`, query, config)
  }

  // 薯价行情数据接口
  /**
   * 获取主产区行情
   * @param {*} query
   * @param {*} config
   * @returns
   */
  getProductionNews(query = {}, config = {}) {
    return service.get(`/www/api/productionNews`, query, config)
  }

  /**
   * 获取销区价格列表
   * @param {*} query
   * @param {*} config
   * @returns
   */
  getMarketPrice(query = {}, config = {}) {
    return service.get(`/www/api/marketPrice?pageSize=${query.pageSize}&pageNum=${query.pageNum}`, query, config)
  }

  /**
   * 获取市场一周行情报价
   * @param {*} query
   * @param {*} config
   * @returns
   */
  getWeekPrice(query = {}, config = {}) {
    return service.get(`/www/api/weekPrice/${query.areaId}`, query, config)
  }
  /**
   * 价格走势区域查询
   * @param {*} query
   * @param {*} config
   * @returns
   */
  getRootArea(query = {}, config = {}) {
    return service.get(`/www/api/rootArea`, query, config)
  }
  /**
   * 价格走势数据查询
   * @param {*} query
   * @param {*} config
   * @returns
   */
  getPriceTendency(query = {}, config = {}) {
    return service.get(`/www/api/priceTendency/${query.year}/${query.mouth}?areaId=${query.areaId}`, query, config)
  }

  /**
   * 提交合作申请
   * @param {*} query
   * @returns
   */
  addCooperator(params = {}, config = {}) {
    return service.post(`/www/api/addPartner`, params, config)
  }

  /**
   *  通过第三方接口获取数据
   */
  getPriceFromApi(params = {}, config = {}) {
    return market.get('/agri-price-api/api/price', {params})
  }
}


export default api



// WEBPACK FOOTER //
// ./src/assets/js/api.js